export default {
    beforeDestroy() {
        // 自动清空组件 data 中所有数组和对象（但保留特定字段如 userInfo 等）
        // 遍历 data 中所有属性，如果值是数组或对象（且不是 Vue 实例），置为 null
        if (this.$data) {
            Object.keys(this.$data).forEach(key => {
                const val = this.$data[key];
                // 只清理大数组和大对象，避免清理基本类型
                if (Array.isArray(val) && val.length > 50) {
                    this.$data[key] = [];
                } else if (val && typeof val === 'object' && !val.__ob__ && !val._isVue) {
                    // 普通对象，但可能包含大数组，可选择性清理，这里不做过度清理
                    // 我们可以只清理特定名称的属性（如 tableData, list 等）
                    if (key.includes('TableData') || key.includes('List') || key.includes('Data')) {
                        this.$data[key] = null;
                    }
                }
            });
        }
    }
};